import { useLanguage } from "@/LanguageContext";
import { motion } from "framer-motion";

const HERO_IMG =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_senior-care-valais/artifacts/9bc7f9efc98e50bb_840033105_1607418347510726_5774201245743093162_n.jpg";

const heroAlt = {
  fr: "Une accompagnante et un monsieur âgé en promenade au bord d'un lac de montagne",
  de: "Eine Begleiterin und ein älterer Herr bei einem Spaziergang am Bergsee",
  en: "A caregiver and an elderly gentleman walking by a mountain lake",
};

export default function HeroSection() {
  const { t, language } = useLanguage();

  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center bg-[#F0EBE3] overflow-hidden pt-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="order-2 lg:order-1"
          >
            <p className="text-sm font-body uppercase tracking-[0.2em] text-[#6FA8B6] mb-6">
              Présence & Sourire
            </p>
            <h1 data-testid="hero-title" className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight text-[#2C3E50] mb-6">
              {t("hero.title")}
            </h1>
            <p className="font-body text-base lg:text-lg text-[#2C3E50]/70 leading-relaxed mb-10 max-w-lg">
              {t("hero.subtitle")}
            </p>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => scrollTo("contact")}
                className="border border-[#6FA8B6] text-[#6FA8B6] font-body font-medium px-8 py-3.5 rounded-full hover:bg-[#6FA8B6]/5 transition-colors text-sm"
                data-testid="hero-cta-contact"
              >
                {t("hero.cta2")}
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            className="order-1 lg:order-2 flex justify-center lg:justify-end"
          >
            <div className="w-full max-w-md mx-auto lg:mx-0 aspect-[4/3] rounded-3xl overflow-hidden shadow-lg">
              <img
                src={HERO_IMG}
                alt={heroAlt[language] || heroAlt.fr}
                width={600}
                height={450}
                fetchPriority="high"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
